
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"-15182.649 16848.35 12.61 13.301"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('g',{attrs:{"id":"Symbol_195_94","data-name":"Symbol 195 – 94","transform":"translate(5259 658)","opacity":".64"}},[_c('g',{attrs:{"id":"Group_8284","data-name":"Group 8284","transform":"translate(-20441.699 16190.2)"}},[_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3664","d":"M3.321 11.007a6.575 6.575 0 0 1-1.862-.621A1.374 1.374 0 0 1 .7 9.007V2.524a1.062 1.062 0 0 1 .69-1.034A9.33 9.33 0 0 1 5.045.8a9.33 9.33 0 0 1 3.655.69 1.207 1.207 0 0 1 .69 1.034","data-name":"Path 3664"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3665","d":"M.7 4.4a4.9 4.9 0 0 0 2.621 1.1","data-name":"Path 3665","transform":"translate(0 -1.117)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3666","d":"M7.307 14.414h6.483a.183.183 0 0 0 .21-.207v-8A.22.22 0 0 0 13.79 6H7.307a.22.22 0 0 0-.207.207v8a.183.183 0 0 0 .207.207z","data-name":"Path 3666","transform":"translate(-1.986 -1.614)"}}),_c('path',{staticClass:"cls-2",attrs:{"id":"Path_3667","d":"M.7 9.1a5.5 5.5 0 0 0 2.621 1.1","data-name":"Path 3667","transform":"translate(0 -2.576)"}})])])])
          )
        }
      }
    